<div class="relative flex flex-col min-h-screen overflow-hidden">
    <app-header [ngClass]="isDetailPage() && isMobile() ? 'hidden' : 'block'" />
    <div #outlet class="flex flex-col flex-1 overflow-x-hidden overflow-y-auto size-full">
        <router-outlet></router-outlet>
    </div>
    <app-footer class="z-40" [ngClass]="isDetailPage() && isMobile() ? 'hidden' : 'block'" />
</div>
